import $ from 'jquery';
import CartFragments from './cart-fragments';

/* global x5script, wc_add_to_cart_params */

class AddToCartAjax {
  constructor() {
    this.isAjaxEnabled = x5script.addToCartAjax;

    this.body = $(document.body);
    this.slideCart = $('.js-slide-cart');
    this.slideCartContent = this.slideCart.find('.js-slide-cart-inner');
    this.isProcessing = false;

    this.toggleSlideCart();
    this.initslideCart();

    if (!this.isAjaxEnabled) {
      return;
    }

    this.cartFragments = new CartFragments();

    this.addToCart();
    this.removeFromCart();
    this.updateCartSession();

    this.body.on('wc_fragments_refreshed', () => {
      this.addToCart();
      this.removeFromCart();
      this.updateCartSession();
    });
  }

  updateCartSession() {
    if (
      this.body.hasClass('woocommerce-cart') ||
      this.body.hasClass('woocommerce-checkout')
    ) {
      this.updateCart();
    }
  }

  addToCart() {
    this.btn = $('.js-add-to-cart-btn-ajax');

    if (!this.btn.length) {
      return;
    }

    this.btn.on('click', e => {
      e.preventDefault();
      const button = $(e.currentTarget);
      const form = button.closest('form.cart');
      const id = button.val();
      const productQtyFromElement =
        form.find('input[name=quantity]').val() || button.attr('data-qty');
      const productQty = productQtyFromElement || 1;
      const productId = form.find('input[name=product_id]').val() || id;
      const variationId = form.find('input[name=variation_id]').val() || 0;

      if (!productId || button.is('.disabled') || this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      e.preventDefault();

      const ajaxData = {
        action: 'add_to_cart_ajax',
        product_id: productId,
        product_sku: '',
        quantity: productQty,
        variation_id: variationId,
      };

      this.body.trigger('adding_to_cart', [button, ajaxData]);

      $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: ajaxData,
        beforeSend: () => {
          button.removeClass('added').addClass('loading');
        },
        complete: () => {
          button.addClass('added').removeClass('loading');
        },
        success: response => {
          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }

          this.cartFragments.set(response.cart);

          if (response.cart_url) {
            window.location = response.cart_url;
            return;
          }

          this.body.trigger('added_to_cart', [
            response.fragments,
            response.cart_hash,
            button,
          ]);

          this.slideCartContent.html(response.cart);
          this.slideCart.addClass('is-open');
          this.isProcessing = false;
        },
      });
    });
  }

  removeFromCart() {
    this.btn = $('.js-remove-ajax');

    this.slideCart.on('click', '.js-remove-ajax', e => {
      const button = $(e.currentTarget);
      const itemKey = button.attr('data-item-key');

      if (!itemKey || this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      button.hide();
      button.parent().addClass('is-removing');
      e.preventDefault();

      const ajaxData = {
        action: 'remove_from_cart_ajax',
        cart_item_key: itemKey,
      };

      $.post(wc_add_to_cart_params.ajax_url, ajaxData, response => {
        if (!response || !response.fragments) {
          window.location = button.attr('href');
          return;
        }

        this.body.trigger('removed_from_cart', [
          response.fragments,
          response.cart_hash,
          button,
        ]);

        this.slideCartContent.html(response.cart);
        this.cartFragments.set(response.cart);
        this.isProcessing = false;
      }).fail(() => {
        window.location = button.attr('href');
      });
    });
  }

  updateCart() {
    this.isProcessing = true;

    const ajaxData = {
      action: 'get_cart_ajax',
    };

    $.post(wc_add_to_cart_params.ajax_url, ajaxData, response => {
      if (!response || !response.fragments) {
        return;
      }

      this.cartFragments.set(response.cart);
      this.isProcessing = false;
    });
  }

  initslideCart() {
    $(window).on('load', () => {
      this.slideCart
        .css('right', -this.slideCart.outerWidth())
        .animate({ opacity: 1 }, 300);

      const cartContent = this.cartFragments.get() || '';

      if (cartContent.length) {
        this.slideCartContent.html(cartContent);
      }
    });

    // let debounce;
    // $(window).on('resize', () => {
    //   clearTimeout(debounce);

    //   debounce = setTimeout(() => {
    //     this.slideCart.css('right', -this.slideCart.outerWidth());
    //   }, 250);
    // });
  }

  toggleSlideCart() {
    this.slideCartToggle = this.slideCart.find('.js-slide-cart-toggle');
    this.slideCartOpenIcon = this.slideCart.find('.js-slide-cart-open');
    this.slideCartCloseIcon = this.slideCart.find('.js-slide-cart-close');

    this.slideCartToggle.on('click', () => {
      this.slideCart.toggleClass('is-open');
    });
  }
}

export default new AddToCartAjax();



// WEBPACK FOOTER //
// ./src/scripts/modules/add-to-cart-ajax.js